<template>
  <div style="margin-left: 25px; margin-top: 17px;">
    <div class="a-header">
      <button @click="toggleChangePassword">
        <i class="fa-solid fa-arrows-rotate"></i>
        <span>Đổi Mật Khẩu</span>
      </button>
    </div>

    <div class="content">
      <div class="container">
        <div class="header">
          <h1>Thông Tin Tài Khoản</h1>
        </div>

        <div class="user-info">
          <div class="form-group">
            <label for="username">Tên người dùng:</label>
            <input type="text" id="username" v-model="getUserName" readonly>
          </div>

          <div class="form-group">
            <label for="email">Email:</label>
            <input type="text" id="email" v-model="getEmail" readonly>
          </div>
        </div>

        <div class="roles-permissions">
          <div class="form-group">
            <label for="roles">Vai trò:</label>
            <select id="roles" multiple>
              <option v-for="role in roleToText" :key="role">{{ role }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="permissions">Quyền hạn:</label>
            <select id="permissions" multiple>
              <option v-for="permission in permissionToText" :key="permission">{{ permission }}</option>
            </select>
          </div>
        </div>
      </div>
      <!-- <div class="info">
        <div class="display">
          <div>
            <label>Username:</label><br>
            <input type="text" class="non-editable input-control" :value="getUserName" disabled="disabled">
          </div>

          <div>
            <label>Email:</label><br>
            <input type="text" class="non-editable input-control" :value="getEmail" disabled="disabled">
          </div>
        </div>

        <div class="display">
          <div>
            <label>Roles:</label><br>
            <textarea class="non-editable textarea-control" v-model="roleToText" disabled="disabled"></textarea>
          </div>

          <div>
            <label>Permissions:</label><br>
            <textarea class="non-editable textarea-control" v-model="permissionToText" disabled="disabled"></textarea>
          </div>
        </div>
      </div> -->
      <div class="password-form">
        <form v-if="changePassword" @submit.prevent="changeUserPassword">
          <h2>Đổi Mật Khẩu</h2>
          <div class="pw-box">
            <label>Mật khẩu cũ</label><span style="color: red;">*</span><br>
            <input type="password" class="input-control-pw" v-model="oldPassword">
          </div>
          <div class="pw-box">
            <label>Mật khẩu mới</label><span style="color: red;">*</span><br>
            <input type="password" class="input-control-pw" v-model="newPassword">
          </div>
          <div class="pw-box">
            <label>Xác nhận mật khẩu mới</label><span style="color: red;">*</span><br>
            <input type="password" class="input-control-pw" v-model="confirmPassword">
          </div>
          <button :class="{ loading: requestLoading }" :disabled="requestLoading">
            <p class="btn-text"><i class="fa-solid fa-floppy-disk"></i>Lưu</p>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      changePassword: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      isValid: true,
      roles: ['Admin', 'Test Role'],
      permissions: ['Create User', 'Delete User', 'View User', 'Edit User'],
      requestLoading: false
    }
  },
  computed: {
    roleToText () {
      return this.$store.state.userRoles
    },
    permissionToText () {
      return this.$store.state.userPermissions
    },
    getUserName () {
      return this.$store.state.username
    },
    getEmail () {
      return this.$store.state.email
    }
  },
  methods: {
    toggleChangePassword () {
      this.changePassword = !this.changePassword
    },
    validateData () {
      this.isValid = true
      if (this.newPassword === '' || this.confirmPassword === '' || this.oldPassword === '') {
        this.isValid = false
        this.$showError('Thiếu các thông tin cần thiết')
      } else if (this.newPassword !== this.confirmPassword) {
        this.isValid = false
        this.$showError('Mật khẩu và mật khẩu xác nhận không giống nhau')
      }
    },
    async changeUserPassword () {
      this.requestLoading = true
      this.validateData()
      if (!this.isValid) {
        this.requestLoading = false
        return
      }

      const updatedUser = {
        id: this.$store.state.userId,
        username: this.$store.state.username,
        email: this.$store.state.email,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        activated: true
      }

      try {
        await this.$store.dispatch('users/updateUser', updatedUser)
        this.requestLoading = false
        this.$showSuccess('Đổi mật khẩu thành công')
      } catch (error) {
        this.requestLoading = false
        this.isValid = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn!')
        }
      }
    }
  }
}
</script>

<style scoped>
body {
  font-family: 'Roboto', sans-serif;
  background-color: #e9ecef;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
}

.container {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 650px;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.header h1 {
  font-size: 24px;
  margin: 0;
}

.user-info, .roles-permissions {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
  color: #495057;
}

.form-group input[type="text"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background-color: #f8f9fa;
}

.form-group input[readonly] {
  background-color: #e9ecef;
}

.roles-permissions {
  display: flex;
  justify-content: space-between;
}

.roles-permissions .form-group {
  width: 48%;
}

.form-group select {
  width: 100%;
  height: 120px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background-color: #f8f9fa;
  overflow: auto;
}

.form-group select option {
  padding: 5px;
}

.form-group select:hover {
  background-color: #e2e6ea;
}
  .a-header{
    display: flex;
    justify-content: space-between;
    justify-items: center;
  }

  .a-header button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
    background-color: #0298cf;
  }

  i {
    margin-right: 10px;
  }

  .content {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
  }

  .info {
    width: 800px;
  }

  .password-form {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .display {
    display: flex;
    margin-bottom: 30px;
  }

  .non-editable {
    background-color: rgb(155, 149, 149, 0.3);
    cursor: default;
  }

  .input-control {
    margin-top: 5px;
    height: 40px;
    width: 240px;
    font-size: 20px;
    padding: 0px 10px;
    margin-right: 200px;
    border-radius: 6px;
    border: none;
  }

  .textarea-control {
    margin-top: 5px;
    height: 80px;
    width: 240px;
    font-size: 20px;
    padding: 0px 10px;
    margin-right: 200px;
    border-radius: 6px;
    border: none;
  }

  .hidden {
    visibility: hidden;
  }

  form {
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26); */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  form h2 {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .pw-box {
    margin-top: 20px;
  }

  .input-control-pw {
    margin-top: 5px;
    height: 40px;
    width: 240px;
    font-size: 20px;
    padding: 0px 10px;
    border-radius: 6px;
    border: 1px solid black;
  }

  form button {
    position: relative;
    margin-top: 30px;
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 15px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .green {
    padding: 20px 50px;
    color: green;

  }
  .red {
    padding: 20px 60px;
    color: red;
    text-align: center;
  }
</style>
